<template>
  <div class="card">
    <Toast />
    <div class="title">Daftar Katalog</div>

    <!-- Add print preview template -->
    <div id="print-preview" class="print-preview" v-if="showPreview">
      <div class="preview-header">
        <h4>Preview Cetak</h4>
        <Button
          icon="pi pi-times"
          class="p-button-rounded p-button-text"
          @click="closePreview"
        />
      </div>
      <div class="preview-content">
        <div class="company-header">
          <div class="logo">
            <img src="/assets/images/logo.png" alt="mode_logo" />
          </div>
          <div class="company-info">
            <h4 class="header-title"><b>MODE FASHION GROUP</b></h4>
            <h6 class="header-subtitle">Jl.Laksana</h6>
            <h6 class="header-subtitle">Telp. (061) 6643780</h6>
          </div>
        </div>

        <div class="border-header"></div>

        <div class="header-container">
          <h4 class="title"><b>Distribusi Barang Sisa</b></h4>
          <p class="subtitle">Tanggal: {{ currentDate }}</p>
        </div>

        <DataTable :value="selectedItems" class="p-datatable-sm">
          <Column field="code" header="Kode" style="width: 100px"></Column>
          <Column field="name" header="Nama" style="width: 200px"></Column>
          <Column
            field="sup_code"
            header="Kode Supplier"
            style="width: 120px"
          ></Column>
          <Column
            field="sup_name"
            header="Nama Supplier"
            style="width: 200px"
          ></Column>
          <Column field="price" header="Harga" style="width: 120px">
            <template #body="slotProps">
              <template v-if="isWarehouseUser">
                <div>
                  {{ slotProps.data.cap_price | currency2Decimal }} (HM)
                </div>
                <div>{{ slotProps.data.price | currency }}</div>
              </template>
              <template v-else>
                {{ slotProps.data.price | currency }}
              </template>
            </template>
          </Column>
          <Column field="stock" header="Stok" style="width: 80px"></Column>
        </DataTable>

        <div class="preview-actions">
          <Button
            label="Print"
            icon="pi pi-print"
            class="p-button-primary"
            @click="printPreview"
          />
          <Button
            label="Close"
            icon="pi pi-times"
            class="p-button-secondary"
            @click="closePreview"
          />
        </div>
      </div>
    </div>

    <DataView
      :value="items"
      :lazy="true"
      :paginator="true"
      :rows="limit"
      :totalRecords="total_records"
      :layout="layout"
      @page="getItems($event)"
    >
      <template #header>
        <div class="filter-section p-fluid">
          <div class="p-grid">
            <div class="p-col-12 p-md-6 p-lg-3">
              <span class="p-float-label">
                <InputText
                  id="category"
                  v-model="filter.category"
                  class="w-100"
                />
                <label for="category">Kategori</label>
              </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3">
              <span class="p-input-icon-right w-100" style="display: block">
                <i
                  v-if="loading.suppliers"
                  class="pi pi-spin pi-spinner"
                  style="z-index: 10"
                ></i>
                <AutoComplete
                  id="supplier"
                  v-model="supplier_selected"
                  :suggestions="autoFilteredValue"
                  field="alias"
                  @complete="searchSupplier($event)"
                  :dropdown="true"
                  placeholder="Cari supplier..."
                  class="w-100"
                >
                  <template #item="slotProps">
                    <div class="warehouse-item">
                      <span class="warehouse-text">{{
                        slotProps.item.alias
                      }}</span>
                    </div>
                  </template>
                </AutoComplete>
              </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3">
              <span class="p-float-label">
                <InputText id="name" v-model="filter.name" class="w-100" />
                <label for="name">Nama</label>
              </span>
            </div>
            <div class="p-col-12 p-md-6 p-lg-3">
              <span class="p-float-label">
                <InputText id="code" v-model="filter.code" class="w-100" />
                <label for="code">Kode</label>
              </span>
            </div>
          </div>

          <div class="p-grid p-mt-3">
            <div class="p-col-12">
              <div class="p-jc-center p-ai-center button-group">
                <Button
                  label="Cari"
                  icon="pi pi-search"
                  class="p-button-info p-button-sm search-btn p-mr-2"
                  @click="getItems()"
                  v-shortkey="['enter']"
                  @shortkey="getItems()"
                />
                <Button
                  label="Reset"
                  icon="pi pi-refresh"
                  class="p-button-secondary p-button-sm p-mr-2"
                  @click="resetFilters()"
                  v-tooltip.top="'Reset Filter'"
                />
                <Button
                  v-if="selectedItems.length > 0 && canPreviewPrint"
                  label="Preview"
                  icon="pi pi-file-pdf"
                  class="p-button-warning p-button-sm preview-btn"
                  :loading="loading.preview"
                  @click="handlePrintPreview"
                />
                <Button
                  v-else-if="canPreviewPrint"
                  label="Preview"
                  icon="pi pi-file-pdf"
                  class="p-button-warning p-button-sm preview-btn p-button-outlined"
                  @click="showSelectionRequired"
                />
              </div>
            </div>
          </div>

          <div class="p-grid p-mt-3">
            <div class="p-col-12 p-md-8">
              <div class="p-d-flex p-ai-center">
                <div class="p-field-checkbox p-mr-3">
                  <Checkbox
                    v-model="filter.show_empty_stock"
                    :binary="true"
                    :disabled="checkbox_ative.show_empty_stock"
                    @change="getItems()"
                    inputId="showAll"
                  />
                  <label for="showAll">Tampil Semua</label>
                </div>
                <div class="p-field-checkbox p-mr-3">
                  <Checkbox
                    v-model="filter.show_no_image"
                    :binary="true"
                    @change="getItems()"
                    :disabled="checkbox_ative.show_no_image"
                    inputId="noImage"
                  />
                  <label for="noImage">No Image</label>
                </div>
                <div class="p-field-checkbox" v-if="canSelectItems">
                  <Checkbox
                    v-model="selectAll"
                    @change="toggleSelectAll"
                    :binary="true"
                    inputId="selectAll"
                  />
                  <label for="selectAll">Pilih Semua</label>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-4">
              <div class="p-d-flex p-jc-end">
                <DataViewLayoutOptions v-model="layout" />
              </div>
            </div>
          </div>

          <div class="p-grid p-mt-3" v-if="items.length > 0">
            <div class="p-col-12">
              <div class="stats-card p-d-flex p-jc-between p-ai-center">
                <div class="stat-item">
                  <span class="stat-label">Total Item</span>
                  <span class="stat-value">{{ total_records | number }}</span>
                </div>
                <div class="stat-item">
                  <span class="stat-label">Total Stok</span>
                  <span class="stat-value">{{ all_stock | number }}</span>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="loading.filter"
            class="p-d-flex p-ai-center p-jc-center p-mt-3"
            style="height: 200px"
          >
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
            <span class="p-ml-2">Mengambil data barang. Mohon tunggu...</span>
          </div>
          <div
            v-else-if="!loading.filter && items.length == 0"
            class="p-d-flex p-ai-center p-jc-center p-mt-3"
          >
            <span class="p-text-secondary">Data Tidak Ditemukan</span>
          </div>
        </div>
      </template>

      <template #list="slotProps">
        <div class="p-col-12">
          <div class="product-list-item">
            <Checkbox
              v-if="canSelectItems"
              class="p-mr-2"
              v-model="selectedItems"
              :binary="false"
              :value="slotProps.data"
            />

            <img
              :src="
                slotProps.data.thumbnail ? slotProps.data.thumbnail : no_image
              "
              :alt="slotProps.data.name"
            />
            <div class="product-list-detail">
              <div class="product-description-code">
                {{ slotProps.data.code }}
              </div>
              <div class="product-name">{{ slotProps.data.name }}</div>
              <div class="product-description">
                {{ slotProps.data.supplier }}
              </div>
              <div class="product-description">
                {{ slotProps.data.sup_code }} - {{ slotProps.data.sup_name }}
              </div>
              <i class="pi pi-tag product-category-icon"></i>
              <span class="product-category">
                {{ slotProps.data.cat_name }}
              </span>
            </div>
            <div class="product-list-action">
              <span class="product-cap-price" v-if="showCapPrice"
                >{{ slotProps.data.cap_price | currency2Decimal }} (HM)</span
              >
              <span class="product-price" v-if="showRegularPrice">{{
                slotProps.data.price | currency
              }}</span>
              <span class="product-price"
                >Stok: {{ slotProps.data.stock }}</span
              >
              <span style="text-align: right" v-if="canPushItems">
                <Button
                  icon="pi pi-upload"
                  @click="pushItem(slotProps.data.id)"
                ></Button>
              </span>
              <span style="text-align: right">
                &nbsp;
                <router-link
                  :to="{
                    name: 'catalog-detail',
                    query: { id: slotProps.data.id }
                  }"
                >
                  <Button icon="pi pi-eye"></Button>
                </router-link>
              </span>
            </div>
          </div>
        </div>
      </template>

      <template #grid="slotProps">
        <div class="p-d-flex p-col-12 p-md-3">
          <div class="product-grid-item card">
            <div class="product-grid-item-top">
              <div>
                <Checkbox
                  v-if="canSelectItems"
                  class="p-mr-2"
                  v-model="selectedItems"
                  :binary="false"
                  :value="slotProps.data"
                />

                <i class="pi pi-tag product-category-icon"></i>
                <span class="product-category">{{
                  slotProps.data.cat_name
                }}</span>
              </div>
              <span>Stok: {{ slotProps.data.stock }}</span>
            </div>
            <div class="product-grid-item-content">
              <div>
                <img
                  :src="
                    slotProps.data.thumbnail
                      ? slotProps.data.thumbnail
                      : no_image
                  "
                  :alt="slotProps.data.name"
                />
              </div>
              <div class="product-description-code">
                {{ slotProps.data.code }}
              </div>
              <div class="product-name">{{ slotProps.data.name }}</div>
              <div class="product-description">
                {{ slotProps.data.sup_code }} - {{ slotProps.data.sup_name }}
              </div>
              <div v-if="slotProps.data.docDate">
                <div
                  class="product-description"
                  v-if="slotProps.data.docDate == '0001-01-01T00:00:00Z'"
                >
                  -
                </div>
                <div class="product-description" v-else>
                  {{ slotProps.data.docDate.substr(0, 10) | formatDate }}
                </div>
              </div>
            </div>
            <div class="product-grid-item-bottom">
              <span class="product-cap-price" v-if="showCapPrice"
                >{{ slotProps.data.cap_price | currency2Decimal }} (HM)</span
              >
              <span class="product-price" v-if="showRegularPrice">{{
                slotProps.data.price | currency
              }}</span>

              <router-link
                :to="{
                  name: 'catalog-detail',
                  query: { id: slotProps.data.id }
                }"
              >
                <Button icon="pi pi-eye"></Button>
              </router-link>
            </div>
          </div>
        </div>
      </template>
    </DataView>
  </div>
</template>

<script>
import noImage from '../../assets/images/no-image.png'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      layout: 'list',
      loading: {
        filter: false,
        preview: false,
        suppliers: false
      },
      checkbox_ative: {
        show_empty_stock: false,
        show_no_image: false
      },

      filter: {
        category: '',
        name: '',
        code: '',
        show_empty_stock: true,
        show_no_image: false
      },

      supplier_selected: null,
      autoFilteredValue: [],

      items: [],
      catalog: [],
      selectedItems: [],

      limit: 8,
      total_records: 0,
      all_stock: 0,
      no_image: noImage,
      selectAll: false,
      currentPage: 0,
      showPreview: false,
      currentDate: new Date().toLocaleDateString('id-ID')
    }
  },
  computed: {
    ...mapState(['user']),

    // User type detection
    isWarehouseUser() {
      return (
        (this.user.role === 'WAREHOUSE_MANAGER' ||
          this.user.role === 'WAREHOUSE_STOCK_OPNAME' ||
          this.user.role === 'PURCHASING') &&
        this.user.warehouse_id &&
        this.user.warehouse_id !== 0 &&
        (!this.user.outlet_id || this.user.outlet_id === 0)
      )
    },

    isOutletUser() {
      return (
        this.user.outlet_id &&
        this.user.outlet_id !== 0 &&
        !this.isWarehouseUser
      )
    },

    // Feature flags
    canSelectItems() {
      return (
        this.user.role === 'WAREHOUSE_MANAGER' ||
        this.user.role === 'DISTRIBUTION'
      )
    },

    canPushItems() {
      return this.user.role === 'WAREHOUSE_MANAGER'
    },

    canPreviewPrint() {
      return (
        this.user.role === 'WAREHOUSE_MANAGER' ||
        this.user.role === 'DISTRIBUTION'
      )
    },

    // Price display flags
    showCapPrice() {
      // Show HM (cap_price) for warehouse users
      return this.isWarehouseUser
    },

    showRegularPrice() {
      // Always show regular price (both warehouse and outlet users)
      return true
    }
  },
  mounted() {
    this.getItems()
  },

  methods: {
    // Build API parameters based on user type
    buildApiParams(page = 1, includePagination = true) {
      const params = new URLSearchParams({
        category: this.filter.category || '',
        name: this.filter.name || '',
        code: this.filter.code || '',
        show_empty_stock: this.filter.show_empty_stock,
        show_no_image: this.filter.show_no_image
      })

      if (includePagination) {
        params.append('page', page)
        params.append('limit', this.limit)
      }

      if (this.supplier_selected && this.supplier_selected.code) {
        params.append('supplier', this.supplier_selected.code)
      }

      return params
    },

    // Get API endpoint based on user type
    getApiEndpoint() {
      return this.isWarehouseUser ? '/warehouse-items' : '/outlet-items'
    },

    // Process API response based on user type
    processApiResponse(response) {
      if (this.isWarehouseUser) {
        return {
          items: response.data.data.items.map(image => ({
            ...image,
            thumbnail: image.thumbnail,
            url: image.thumbnail
          })),
          total: response.data.data.total,
          all_stock: null // Will be calculated separately
        }
      } else {
        return {
          items: response.data.data.items,
          total: response.data.data.total,
          all_stock: response.data.data.all_stock
        }
      }
    },

    async getItems(event) {
      let page = 1
      if (event) {
        page = event.page + 1
      }
      this.items = []
      this.loading.filter = true
      this.checkbox_ative.show_empty_stock = true
      this.checkbox_ative.show_no_image = true

      try {
        const params = this.buildApiParams(page, true)
        const endpoint = this.getApiEndpoint()

        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}${endpoint}?${params.toString()}`
        )

        if (response.status === 200) {
          this.loading.filter = false
          this.checkbox_ative.show_empty_stock = false
          this.checkbox_ative.show_no_image = false

          const processedData = this.processApiResponse(response)
          this.items = processedData.items
          this.total_records = processedData.total

          if (this.isWarehouseUser) {
            // Calculate stock separately for warehouse users
            await this.calculateStock()
          } else {
            // Outlet users get stock from API response
            this.all_stock = processedData.all_stock
          }
        } else {
          this.loading.filter = false
          this.showToast('error', 'Error', 'Gagal mengambil data')
        }
      } catch (error) {
        this.loading.filter = false
        this.checkbox_ative.show_empty_stock = false
        this.checkbox_ative.show_no_image = false
        console.error('Error fetching items:', error)
        this.showToast(
          'error',
          'Error',
          'Terjadi kesalahan saat mengambil data'
        )
      }
    },

    toggleSelectAll() {
      if (this.selectAll) {
        // Select all current page items that aren't already selected
        this.items.forEach(item => {
          const isAlreadySelected = this.selectedItems.some(
            selected => selected.id === item.id
          )
          if (!isAlreadySelected) {
            this.selectedItems.push(item)
          }
        })
      } else {
        // Deselect all items from current page
        const currentPageIds = this.items.map(item => item.id)
        this.selectedItems = this.selectedItems.filter(
          item => !currentPageIds.includes(item.id)
        )
      }
    },

    pushItem(id) {
      this.$http
        .post(`${process.env.VUE_APP_API_URL}/warehouse/push-items/${id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.showToast('success', 'Success', 'Item has been pushed')
          }
        })
        .catch(error => {
          console.error('Error pushing item:', error)
          this.showToast('error', 'Error', 'Gagal push item')
        })
    },

    async calculateStock() {
      if (!this.isWarehouseUser) {
        return
      }

      try {
        const params = this.buildApiParams(1, false)
        const endpoint = this.getApiEndpoint()

        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}${endpoint}?${params.toString()}`
        )

        if (response.status === 200) {
          this.all_stock = 0
          response.data.data.items.forEach(item => {
            this.all_stock += item.stock
          })
        }
      } catch (error) {
        console.error('Error calculating stock:', error)
      }
    },

    showSelectionRequired() {
      this.$toast.add({
        severity: 'info',
        summary: 'Pilih Item',
        detail: 'Silakan pilih item yang ingin dilihat preview cetaknya',
        life: 3000
      })
    },

    async handlePrintPreview() {
      try {
        this.loading.preview = true

        // Validate selected items
        if (!this.selectedItems || this.selectedItems.length === 0) {
          this.showSelectionRequired()
          return
        }

        // Show preview dialog
        this.showPreview = true
      } catch (error) {
        console.error('Error preparing print preview:', error)
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Gagal memuat preview cetak. Silakan coba lagi.',
          life: 3000
        })
      } finally {
        this.loading.preview = false
      }
    },

    closePreview() {
      this.showPreview = false
    },

    async printPreview() {
      try {
        // Store the selected items in localStorage with a unique key
        const printDataKey = 'print_catalog_data_' + Date.now()
        localStorage.setItem(printDataKey, JSON.stringify(this.selectedItems))

        // Open print page in new tab with the storage key
        const printWindow = window.open('', '_blank')
        const routeData = this.$router.resolve({
          name: 'print-selected-catalog-list',
          query: {
            key: printDataKey
          }
        })
        printWindow.location.href = routeData.href

        // Close the preview dialog
        this.closePreview()
      } catch (error) {
        console.error('Error printing:', error)
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Gagal mencetak. Silakan coba lagi.',
          life: 3000
        })
      }
    },

    // Reset selection when filters change
    resetSelection() {
      this.selectAll = false
      // Note: selectedItems persist across pages as per requirement
    },

    async resetFilters() {
      this.filter.category = ''
      this.filter.name = ''
      this.filter.code = ''
      this.filter.show_empty_stock = true
      this.filter.show_no_image = false
      this.supplier_selected = null
      this.selectAll = false
      this.currentPage = 0

      // Reload suppliers for fresh dropdown data
      await this.loadSuppliersForDropdown()

      // Reset to page 1 and reload
      this.getItems()
    },

    async print() {
      this.loading.filter = true

      try {
        const params = this.buildApiParams(1, false)
        const endpoint = this.getApiEndpoint()

        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}${endpoint}?${params.toString()}`
        )

        this.loading.filter = false

        if (response.status === 200) {
          const processedData = this.processApiResponse(response)
          this.catalog = processedData.items

          const routeParams = {
            catalog: this.catalog,
            layout: this.layout
          }

          if (this.isWarehouseUser) {
            routeParams.all_stock = this.all_stock
            routeParams.total_records = this.total_records
          }

          this.$router.push({
            name: 'print-selected-catalog-list',
            params: routeParams
          })
        } else {
          this.showToast('error', 'Error', 'Gagal mengambil data untuk print')
        }
      } catch (error) {
        this.loading.filter = false
        console.error('Error printing:', error)
        this.showToast('error', 'Error', 'Terjadi kesalahan saat mencetak')
      }
    },

    // Debounce utility method
    debounce(fn, delay) {
      let timeout
      return function (...args) {
        clearTimeout(timeout)
        timeout = setTimeout(() => fn.apply(this, args), delay)
      }
    },

    // API-based supplier loading with limit
    async getSuppliers(searchQuery = '', limit = 20) {
      this.loading.suppliers = true
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/suppliers`,
          {
            params: {
              search: searchQuery,
              limit: limit
            }
          }
        )

        if (response.status === 200) {
          return response.data.data.suppliers.map(item => {
            return {
              alias: `${item.code} - ${item.name}`,
              code: item.code,
              id: item.id,
              name: item.name,
              parent: item.parent
            }
          })
        }
        return []
      } catch (error) {
        console.error('Error fetching suppliers:', error)
        this.showToast('error', 'Error', 'Failed to fetch suppliers')
        return []
      } finally {
        this.loading.suppliers = false
      }
    },

    // Load initial suppliers for dropdown (first load when dropdown clicked)
    async loadSuppliersForDropdown() {
      const suppliers = await this.getSuppliers('', 20)
      this.autoFilteredValue = suppliers
    },

    // Actual search method that performs API call (called by debounced wrapper)
    async _searchSuppliers(event) {
      const query = event.query || ''

      // If empty query (dropdown clicked), always load initial suppliers
      if (!query) {
        await this.loadSuppliersForDropdown()
        return
      }

      // API call with search query
      const suppliers = await this.getSuppliers(query, 20)
      this.autoFilteredValue = suppliers
    },

    // Initialize debounced search function
    initDebouncedSearch() {
      if (!this.$_searchSuppliersDebounced) {
        this.$_searchSuppliersDebounced = this.debounce(
          this._searchSuppliers,
          500
        )
      }
    },

    // Wrapper that calls debounced version
    searchSupplier(event) {
      const query = event.query || ''

      // If empty query (dropdown clicked), execute immediately without debounce
      if (!query) {
        this._searchSuppliers(event)
        return
      }

      // For typing/search, use debounce to reduce API calls
      if (!this.$_searchSuppliersDebounced) {
        this.initDebouncedSearch()
      }
      this.$_searchSuppliersDebounced(event)
    }
  }
}
</script>

<style scoped lang="scss">
.filter-section {
  background-color: #f8f9fa;
  padding: 1.5rem;
  border-radius: 6px;
  margin-bottom: 1rem;
}

.w-100 {
  width: 100%;
}

.block {
  display: block;
}

.warehouse-item {
  padding: 0.5rem;

  .warehouse-text {
    font-size: 0.875rem;
    color: #495057;
  }
}

.stats-card {
  background-color: white;
  padding: 1rem;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.stat-item {
  text-align: center;
  padding: 0 2rem;

  .stat-label {
    display: block;
    color: #6c757d;
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
  }

  .stat-value {
    display: block;
    font-size: 1.25rem;
    font-weight: 600;
    color: #495057;
  }
}

.product-name {
  font-size: 1.5rem;
}

.product-description {
  margin: 0 0 1rem 0;
}
.product-description-code {
  margin: 0 0 0 0;
  font-size: 2rem;
  font-weight: 900;
}

.product-category-icon {
  vertical-align: middle;
  margin-right: 0.5rem;
}

.product-category {
  font-weight: 600;
  vertical-align: middle;
}

/deep/ .product-list-item {
  display: flex;
  align-items: center;
  padding: 1rem;
  width: 100%;

  img {
    width: 150px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    margin-right: 2rem;
  }

  .product-list-detail {
    flex: 1 1 0;
  }

  .p-rating {
    margin: 0 0 0.5rem 0;
  }

  .product-price {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
    align-self: flex-end;
  }

  .product-cap-price {
    display: block;
  }

  .product-list-action {
    display: flex;
    flex-direction: column;
  }

  .p-button {
    margin-bottom: 0.5rem;
  }
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

/deep/ .product-grid-item {
  margin: 0.5em;
  border: 1px solid #dee2e6;

  .product-grid-item-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .product-grid-item-bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  img {
    width: 75%;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    margin: 2rem 0;
  }

  .product-grid-item-content {
    text-align: center;
  }

  .product-price {
    font-size: 1.5rem;
    font-weight: 600;
    margin-right: 0.5rem;
  }
}

@media screen and (max-width: 576px) {
  .product-list-item {
    flex-direction: column;
    align-items: center;

    img {
      width: 75%;
      margin: 2rem 0;
    }

    .product-list-detail {
      text-align: center;
    }

    .product-price {
      align-self: center;
    }

    .product-list-action {
      display: flex;
      flex-direction: column;
      margin-top: 2rem;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }
  }
}

.button-group {
  display: inline-flex;
  margin: 0 auto;
  gap: 0.5rem;
}

.p-button-sm {
  padding: 0.5rem 1.25rem;
  font-size: 0.875rem;
  min-width: 90px;
  width: auto;
  white-space: nowrap;

  .p-button-icon {
    font-size: 0.875rem;
    margin-right: 0.5rem;
  }
}

.search-btn {
  min-width: 80px;
}

.print-btn {
  min-width: 80px;
}

.preview-btn {
  min-width: 90px;
}

.p-button-outlined {
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
}

.print-preview {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-content {
  background: white;
  padding: 2rem;
  border-radius: 6px;
  width: 90%;
  max-width: 1200px;
  max-height: 90vh;
  overflow-y: auto;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #dee2e6;

  h4 {
    margin: 0;
  }
}

.company-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  .logo {
    margin-right: 1rem;
    img {
      height: 60px;
    }
  }

  .company-info {
    .header-title {
      margin: 0;
      font-size: 1.5rem;
    }
    .header-subtitle {
      margin: 0.25rem 0;
      color: #6c757d;
    }
  }
}

.border-header {
  border-top: 2px solid #dee2e6;
  margin: 1rem 0;
}

.header-container {
  text-align: center;
  margin-bottom: 2rem;

  .title {
    margin: 0;
    font-size: 1.5rem;
  }
  .subtitle {
    margin: 0.5rem 0 0;
    color: #6c757d;
  }
}

.preview-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #dee2e6;
}
</style>
